<div class="mapTrail">
  <div class="grids">
    <div class="ng-star-inserted" *ngIf="apiLoaded">
      <div class="ng-star-inserted" *ngIf="apiLoaded">
        <div class="cards__desktop">
          <app-tabs>
            <app-tab tabTitle="{{ 'monitoring.tabs.title-navigation' | translate }}" #tab2>
              <app-navigation-tab *ngIf="tab2.selected" [navigationTab]="navigationTabInfo"></app-navigation-tab>
            </app-tab>
            @if (machineTabInfo) {
              <app-tab
                tabTitle="{{ 'monitoring.tabs.title-machine' | translate }}"
                [alert]="machineTabInfo.activeDtcCount > 0"
                alertLabel="{{ 'monitoring.tabs.machine.tab-alert' | translate }}"
                #machineTabDesktop>
                @if (machineTabDesktop.selected) {
                  <app-machine-tab [machineTab]="machineTabInfo"></app-machine-tab>
                }
              </app-tab>
            }
            <app-tab
              *ngIf="workStatus === deviceWorkingStatus"
              tabTitle="{{ 'monitoring.tabs.title-operation' | translate }}"
              #tab1>
              <app-operation-tab
                *ngIf="tab1.selected"
                [operationTab]="operationTabInfo"
                [staticMessageOperationTab]="staticMessageOperationTabInfo"></app-operation-tab>
            </app-tab>
            <app-tab
              *ngIf="currentOperationType === isobus && totalTabInfo"
              tabTitle="{{ 'monitoring.tabs.title-totals' | translate }}"
              #tab3>
              <p *ngIf="tab3.selected" class="text-info">
                *{{ 'tasks.tabs.totals.label-title-information' | translate }}
              </p>
              <app-total-tab *ngIf="tab3.selected" [totalTab]="totalTabInfo"></app-total-tab>
            </app-tab>
            <app-tab tabTitle="{{ 'monitoring.maps.title-weather' | translate }}" #tab4>
              <app-weather-tab
                *ngIf="tab4.selected"
                [lat]="location.latitude"
                [long]="location.longitude"></app-weather-tab>
            </app-tab>
          </app-tabs>
        </div>
        <div *ngIf="pointSelected">
          <div class="pointSelected">
            <button (click)="closeInfos()"><i class="agres-close"></i></button>
            <div class="pointSelected__info--text">
              <p>
                {{ 'monitoring.speed' | translate }}: <small>{{ pointVelocity }} km/h</small>
              </p>
              <p>
                {{ 'monitoring.instant_rate' | translate }}: <small>{{ pointInstRate }} {{ pointInstRateUnit }}</small>
              </p>
              <p>
                {{ 'monitoring.date_and_time' | translate }}: <small>{{ pointDate }}</small>
              </p>
              <p>{{ 'monitoring.session_state' | translate }}:</p>
            </div>
            <div class="pointSelected__info">
              <img *ngFor="let sectionArr of pointStatus" [src]="sectionArr" alt="point" />
            </div>
          </div>
        </div>
        <google-map
          width="100%"
          [height]="viewPort4k ? '76vh' : '60vh'"
          [center]="{ lat: mapLat || 0, lng: mapLng || 0 }"
          [zoom]="zoom"
          [options]="{
            disableDefaultUI: true,
            zoomControl: false,
            scaleControl: true,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeId: 'satellite',
            panControl: true,
          }">
          <map-marker
            *ngIf="hasCoordinates()"
            [options]="{
              position: {
                lat: location.latitude,
                lng: location.longitude,
              },
              draggable: false,
              visible: marker,
              icon: {
                url: tractorIconHtml,
              },
            }"
            (mapClick)="markerClick()">
          </map-marker>
          <map-circle
            *ngFor="let circle of circles; let i = index"
            [options]="{
              strokeWeight: 0.6,
              strokeOpacity: 1,
              fillOpacity: 1,
              strokeColor: '#000',
              fillColor: changeColor(circle.selected, circle.instRate, circle.sectionArr, circle.gwAddr, circle.opType),
            }"
            [center]="circle.center"
            [radius]="circle.radius"
            (circleClick)="circleClick(i)" />
        </google-map>
        <div
          class="scaleDisplay"
          *ngIf="
            currentOperationType !== other && currentOperationType !== navigation && workStatus === deviceWorkingStatus
          ">
          <div>
            <small class="text-info">*{{ 'monitoring.edit-and-salve-legends' | translate }}</small>
          </div>
          <div>
            <small class="text-danger" *ngIf="showErrorLegends">*{{ 'monitoring.error-legends' | translate }}</small>
          </div>
          <ul>
            <li id="win02">
              <input
                id="trailColorValue.red"
                type="text"
                [(ngModel)]="trailColorValue.red"
                [ngModelOptions]="{ standalone: true }"
                class="legendText input-custom"
                (ngModelChange)="onTrailColorValueChange()" />
            </li>
            <li id="win03">
              <input
                id="trailColorValue.orange"
                type="text"
                [(ngModel)]="trailColorValue.orange"
                [ngModelOptions]="{ standalone: true }"
                class="legendText input-custom"
                (ngModelChange)="onTrailColorValueChange()" />
            </li>
            <li id="win04">
              <input
                id="trailColorValue.yellow"
                type="text"
                [(ngModel)]="trailColorValue.yellow"
                [ngModelOptions]="{ standalone: true }"
                class="legendText input-custom"
                (ngModelChange)="onTrailColorValueChange()" />
            </li>
            <li id="win05">
              <input
                id="trailColorValue.lemonGreen"
                type="text"
                [(ngModel)]="trailColorValue.lemonGreen"
                [ngModelOptions]="{ standalone: true }"
                class="legendText input-custom"
                (ngModelChange)="onTrailColorValueChange()" />
            </li>
            <li id="win06">
              <input
                id="trailColorValue.green"
                type="text"
                [(ngModel)]="trailColorValue.green"
                [ngModelOptions]="{ standalone: true }"
                class="legendText input-custom"
                (ngModelChange)="onTrailColorValueChange()" />
            </li>
            <li>
              <span class="legendText input-custom">
                {{ 'tasks.application-rate' | translate }}:{{ instRateUnit }}
              </span>
            </li>
          </ul>
        </div>
        <div class="cards__mobile">
          <app-tabs>
            <app-tab tabTitle="{{ 'monitoring.tabs.title-navigation' | translate }}" #tab6>
              <app-navigation-tab *ngIf="tab6.selected" [navigationTab]="navigationTabInfo"></app-navigation-tab>
            </app-tab>
            @if (machineTabInfo) {
              <app-tab
                tabTitle="{{ 'monitoring.tabs.title-machine' | translate }}"
                [alert]="machineTabInfo.activeDtcCount > 0"
                alertLabel="{{ 'monitoring.tabs.machine.tab-alert' | translate }}"
                #machineTabMobile>
                @if (machineTabMobile.selected) {
                  <app-machine-tab [machineTab]="machineTabInfo"></app-machine-tab>
                }
              </app-tab>
            }
            <app-tab
              *ngIf="workStatus === deviceWorkingStatus"
              tabTitle="{{ 'monitoring.tabs.title-operation' | translate }}"
              #tab5>
              <app-operation-tab
                *ngIf="tab5.selected"
                [operationTab]="operationTabInfo"
                [staticMessageOperationTab]="staticMessageOperationTabInfo"></app-operation-tab>
            </app-tab>
            <app-tab
              *ngIf="currentOperationType === isobus && totalTabInfo"
              tabTitle="{{ 'monitoring.tabs.title-totals' | translate }}"
              #tab7>
              <p *ngIf="tab7.selected" class="text-info">
                *{{ 'tasks.tabs.totals.label-title-information' | translate }}
              </p>
              <app-total-tab *ngIf="tab7.selected" [totalTab]="totalTabInfo"></app-total-tab>
            </app-tab>
            <app-tab tabTitle="{{ 'monitoring.maps.title-weather' | translate }}" #tab8>
              <app-weather-tab
                *ngIf="tab8.selected"
                [lat]="location.latitude"
                [long]="location.longitude"></app-weather-tab>
            </app-tab>
          </app-tabs>
        </div>
      </div>
    </div>
  </div>
  <app-modal title="global.status" [show]="showModal" [showSubject]="showModalSubject">
    <div class="alertDevice">
      <i class="agres-fleet-monitoring-off"></i>
      <h6>{{ 'monitoring.deviceNotConnect' | translate }}</h6>
      <div class="alertDevice__actions">
        <app-button
          (btnClick)="goBack()"
          type="button"
          color="return"
          icon="agres-return"
          title="{{ 'global.back' | translate }}">
        </app-button>
      </div>
    </div>
  </app-modal>
</div>
